/*
 * Order minimum - keeps the cart's checkout controls in step with the minimum-order rule.
 *
 * The banner is its own section so that Liquid stays the single source of truth for the copy and
 * the money formatting. Dawn swaps the cart line items in place on every quantity change without
 * touching either the banner or the checkout button, so both are refreshed here: the banner
 * section is re-fetched through the Section Rendering API, and the footer controls are re-synced
 * from the fresh banner's data attributes.
 */
(function () {
  const SECTION_ID = 'order-minimum-banner';
  // In a JSON template the wrapper id is prefixed, e.g.
// shopify-section-template--27950443168061__order-minimum-banner
const HOST_SELECTOR = '[id^="shopify-section-"][id$="' + SECTION_ID + '"]';

  function sync() {
    const banner = document.getElementById('OrderMinimumBanner');
    const button = document.getElementById('checkout');
    const notice = document.getElementById('OrderMinimumNotice');

    // No banner means an empty cart, which Dawn already handles on its own.
    const below = !!banner && banner.dataset.below === 'true';

    document.documentElement.classList.toggle('order-minimum-blocked', below);

    if (button) {
      button.disabled = below || !document.querySelector('.cart-item');
      if (below) {
        button.setAttribute('aria-describedby', 'OrderMinimumNotice');
      } else {
        button.removeAttribute('aria-describedby');
      }
    }

    if (notice) {
      notice.textContent = below ? banner.dataset.message || '' : '';
    }
  }

  function refresh() {
    const host = document.querySelector(HOST_SELECTOR);

    if (!host) {
      sync();
      return;
    }

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + '?section_id=' + SECTION_ID)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(HOST_SELECTOR);
        if (fresh) host.innerHTML = fresh.innerHTML;
      })
      .catch(function () {
        // Leave the last known state in place rather than guessing at it. Checkout still enforces
        // the rule regardless of what the cart manages to show.
      })
      .then(sync);
  }

  let queued = false;

  function queueRefresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      refresh();
    });
  }

  function init() {
    const cartItems = document.querySelector('cart-items');
    if (!cartItems) return;

    sync();
    new MutationObserver(queueRefresh).observe(cartItems, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
